import { expected } from '@aloft/toolkit-shared';

import { useContext } from 'react';

import { StudiesContext } from '../consts.js';
import { useNewStudiesState } from './useNewStudiesState.ts';

export function useStudiesState(): ReturnType<typeof useNewStudiesState>;
export function useStudiesState(
  iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError: boolean,
): ReturnType<typeof useNewStudiesState>;
export function useStudiesState(
  iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError = false,
) {
  const msg = 'useStudiesState called outside of provider';
  const studiesState = useContext(StudiesContext);

  if (studiesState) return studiesState;

  const context = iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError ? {} : undefined;

  return expected(context, msg);
}
